/* PDP use cases
   - Desktop arrows scroll the card row when a tab has more than 4 cards.
   - Card videos play muted while on screen, pause when scrolled away or on a hidden tab,
     and have a pause button. Reduced-motion visitors see the cover until they press play.
   - The button scrolls smoothly to the Bucket PDP hero (or a chosen section ID). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupVideo(video) {
    if (video.dataset.pucReady) return;
    video.dataset.pucReady = '1';
    var btn = video.parentNode.querySelector('[data-puc-toggle]');
    var userPaused = reduce;
    function sync() {
      if (!btn) return;
      btn.hidden = false;
      btn.classList.toggle('is-paused', video.paused);
      btn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }
    function play() { var p = video.play(); if (p && p.catch) p.catch(sync); }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    if (btn) btn.addEventListener('click', function () {
      userPaused = !video.paused;
      if (userPaused) video.pause(); else play();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var on = entries[0].isIntersecting;
        if (on && !userPaused) play();
        else if (!on && !video.paused) video.pause();
      }, { threshold: 0.4 }).observe(video);
    } else if (!userPaused) {
      play();
    }
    sync();
  }

  function setupPanel(panel) {
    var track = panel.querySelector('[data-puc-track]');
    var prev = panel.querySelector('[data-puc-prev]');
    var next = panel.querySelector('[data-puc-next]');
    if (!track || !prev || !next || track.dataset.pucReady) return null;
    track.dataset.pucReady = '1';
    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 2;
      prev.hidden = next.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function step(dir) {
      var card = track.querySelector('li');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: dir * ((card ? card.offsetWidth : 300) + gap) });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return update;
  }

  function setupButton(root) {
    var link = root.querySelector('[data-puc-scroll]');
    if (!link || link.dataset.pucReady) return;
    link.dataset.pucReady = '1';
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('data-puc-scroll');
      var target = (id && document.getElementById(id)) || document.querySelector('[data-bph]');
      if (!target) return; // no hero on this page: let the link behave normally
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-puc]'), function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-puc-video]'), setupVideo);
      var updaters = Array.prototype.map.call(root.querySelectorAll('[data-puc-panel]'), setupPanel).filter(Boolean);
      // A hidden tab can't measure itself, so re-check the arrows when the tab changes.
      Array.prototype.forEach.call(root.querySelectorAll('[data-puc-tab]'), function (radio) {
        radio.addEventListener('change', function () { updaters.forEach(function (u) { u(); }); });
      });
      setupButton(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
